import React, { Fragment, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import CardManagementContainer from "./CardManagementContainer";
import BlockingManager from "./BlockingManager";

const CartesGestionPage = () => {
  const [activeTab, setActiveTab] = useState('management');

  return (
    <Fragment>
      <PageTitle activeMenu="Gestion des Cartes" motherMenu="Cartes" />
      
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-4">
                
                <Tab eventKey="management" title={
                  <span>
                    <i className="la la-search me-2"></i>
                    Recherche & Gestion
                  </span>
                }>
                  <CardManagementContainer />
                </Tab>

                <Tab eventKey="suspension" title={
                  <span>
                    <i className="la la-ban me-2"></i>
                    Blocage & Déblocage
                  </span>
                }>
                  <BlockingManager />
                </Tab>

              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CartesGestionPage;